import styled from 'styled-components';
import { Grid } from 'syf-component-library/ui/patterns';
export const Image = styled.img `
  max-width: 100%;
  max-height: 100%;
`;
export const ImageContainer = styled(Grid) `
  width: 100%;
  display: flex;
  justify-content: center;
`;
